const Watermark = ({ brand = "Nurse Assist International" }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,                      // Ensure it starts from the left edge
      width: "100%",                // Full width of the viewport
      height: "100vh",              // Full height of the viewport
      zIndex: 9999,
      pointerEvents: "none",
      userSelect: "none",
      opacity: 0.12,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",     // Center both horizontally and vertically
      fontSize: "5vw",              // Scales with screen size
      fontWeight: "bold",
      color: "#7e7e7e",
      mixBlendMode: "multiply",
      transform: "rotate(-20deg)",
      letterSpacing: "2vw",
      textAlign: "center",          // In case text wraps
      padding: "0 10px",            // Prevent clipping on very small screens
      boxSizing: "border-box"
    }}
  >
    {brand}
  </div>
);

export default Watermark;
